import React, { useState, useEffect } from "react";

import { CadastroSimples, TipoInformacao } from "../../data/interfaces";
import { getListaBanner } from "../../services/firebase";
import { Container, ImgBanner, Slider, Action } from "./styles";

const Banner: React.FC = () => {
  const [itens, setItens] = useState<CadastroSimples[]>([]);

  useEffect(() => {
    getListaBanner(TipoInformacao.BANNER, (banners: CadastroSimples[]) => {
      setItens(banners);
      startSilider();
    });
  }, []);

  function startSilider() {
    let curretImageIndex = 0;
    const imagesTmp = document.querySelectorAll<HTMLHeadingElement>(
      "div #slider img"
    );
    const max = imagesTmp === undefined ? 0 : imagesTmp.length;
    setInterval(() => {
      if (max > 0) {
        imagesTmp[curretImageIndex].style.opacity = "0";
        imagesTmp[curretImageIndex].style.zIndex = "0";
        curretImageIndex += 1;
        if (curretImageIndex >= max) {
          curretImageIndex = 0;
        }
        imagesTmp[curretImageIndex].style.opacity = "1";
        imagesTmp[curretImageIndex].style.zIndex = "1";
      }
    }, 5000);
  }

  return (
    <Container>
      <Slider id="slider">
        {itens.map((item) => {
          if (!item.noticia) {
            return (
              <Action
                href={item.link}
                target="_blank"
                rel="noreferrer noopener"
              >
                <ImgBanner key={item.key} src={item.urlImage} />
              </Action>
            );
          }
        })}
      </Slider>
    </Container>
  );
};

export default Banner;
